<template>
  <upload-list-item-field label="Source">
    <v-icon size="small">{{ icon }}</v-icon>
    {{ sourceLabel }}
  </upload-list-item-field>
</template>

<script>
import UploadListItemField from '@/components/UploadsPage/UploadListItemField';
import { FileSource } from '@/enums';

const FILE_SOURCE_TO_PROPS = {
  [FileSource.DATABASE]: {
    icon: 'storage',
    sourceLabel: 'Database',
  },
  [FileSource.REGISTRY]: {
    icon: 'cloud',
    sourceLabel: 'Registry',
  },
  [FileSource.OTHER]: {
    icon: 'more_horiz',
    sourceLabel: 'Other',
  },
};

export default {
  name: 'UploadListItemFieldSource',
  components: { UploadListItemField },
  props: {
    source: {
      type: String,
      required: true,
      validator: (value) => Object.values(FileSource).includes(value),
    },
  },
  computed: {
    sourceLabel() {
      return FILE_SOURCE_TO_PROPS[this.source].sourceLabel;
    },
    icon() {
      return FILE_SOURCE_TO_PROPS[this.source].icon;
    },
  },
};
</script>
